import * as charCode from '@/constants/charCode'

export const nl2br = (str: string) => str.replace(/\n/, '<br>')

type SanitizedTokenMapper = {
  '<br>': RegExp
}

const sanitizedTokenMapper: SanitizedTokenMapper = {
  '<br>': new RegExp('&lt;br&gt;', 'g')
}

export const sanitize = (
  str: string,
  exclusions: Array<keyof SanitizedTokenMapper> = []
) => {
  const element = document.createElement('div')
  element.innerText = str

  let sanitizedStr = element.innerHTML
  exclusions.forEach(token => {
    sanitizedStr = sanitizedStr.replace(sanitizedTokenMapper[token], token)
  })

  return sanitizedStr
}

export const capitalize = (str: string) =>
  `${str.slice(0, 1).toUpperCase()}${str.slice(1)}`

const _isHiSurrogate = (code: number) => {
  return (
    charCode.HI_SURROGATE_START <= code && code <= charCode.HI_SURROGATE_END
  )
}

const _isLowSurrogate = (code: number) => {
  return (
    charCode.LOW_SURROGATE_START <= code && code <= charCode.LOW_SURROGATE_END
  )
}

/**
 * 非BMP文字列を上位サロゲートのインデックスを指定して取得する
 * @param  {String} str
 * @param  {Number} index
 * @return {String}
 */
const _getNonBMPString = (str: string, index: number) => {
  const hi = str.charCodeAt(index)
  const low = str.charCodeAt(index + 1)

  if (isNaN(low) === true || _isLowSurrogate(low) === false) {
    return null
  }

  return String.fromCharCode(hi, low)
}

export const mbStrlen = (str: string) => {
  let result = 0

  for (let i = 0; i < str.length; i++) {
    result++

    const code = str.charCodeAt(i)

    if (_isHiSurrogate(code)) {
      i++
    }
  }

  return result
}

export const mbSubstr = (str: string, start: number, length?: number) => {
  if (isFinite(start) === false) {
    console.warn(`start of ${start} is invalid value`)
    return ''
  }

  if (length !== undefined && (length === 0 || length < 0)) {
    console.warn(`length must be more then 0 but ${length} is passed`)
    return ''
  }

  let results = ''
  let currentMbLength = 0

  const end = length !== undefined ? start + length : null

  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i)

    if (_isLowSurrogate(code) === true) {
      continue
    }

    currentMbLength++

    let add = null

    if (_isHiSurrogate(code) === true) {
      add = _getNonBMPString(str, i)
      i++
    } else {
      add = String.fromCharCode(code)
    }

    if (end !== null && currentMbLength > end) {
      break
    }

    if (currentMbLength <= start) {
      continue
    }

    if (add === null) {
      continue
    }

    results = results + add
  }

  return results
}
